import { AppBundle } from '@/utils/app-bundles';
import { LegacyRedirectReporter, RedirectRegexToTargetApp, preHydraJourneysEnvRegex } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function EnvRedirectRoute() {
  return (
    <LegacyRedirectReporter>
      <RedirectRegexToTargetApp regex={preHydraJourneysEnvRegex} targetApp={AppBundle.Journeys} />
    </LegacyRedirectReporter>
  );
}

export const Route = createFileRoute('/env/$')({
  component: EnvRedirectRoute,
});
